module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-21-0b66efabc5c3b06c65df789abb85ebc7.jpg";